import { NgFor, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  ButtonDirective,
  FormInputDirective,
  FormLabelDirective,
  FormRadioComponent,
  SvgComponent,
} from '@app/base-components';
import { ButtonQaId, HabaQaId } from '@app/helpers';
import { Address, I18nModule } from 'haba-core';
import { ModalService } from 'haba-storefrontlib';
import { AddressValidationMelissa } from 'src/app/@interfaces/MelissaData';

@Component({
  selector: 'app-address-melissa-check-modal',
  templateUrl: './address-melissa-check-modal.component.html',
  styleUrls: ['./address-melissa-check-modal.component.scss'],
  imports: [
    SvgComponent,
    ReactiveFormsModule,
    NgFor,
    FormRadioComponent,
    FormInputDirective,
    FormLabelDirective,
    NgTemplateOutlet,
    ButtonDirective,
    I18nModule,
  ],
})
export class AddressMelissaCheckModalComponent implements OnInit {
  form: FormGroup = this.formBuilder.group({ addressIndex: [-1, Validators.required] });
  address: AddressValidationMelissa;

  baseId: HabaQaId;
  closeButtonQaId: ButtonQaId;

  constructor(
    private modalService: ModalService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.initIds();
  }

  close(success: boolean): void {
    this.modalService.dismissActiveModal(success);
  }

  onSubmit(event) {
    event.preventDefault();
    const address = this.selectedAddress();
    this.modalService.dismissActiveModal(address);
  }

  selectedAddress(): Address {
    const index = this.form.get('addressIndex').value;
    const address = index === -1 ? this.address : this.address.fixedAddresses[index];
    address.habaAddressIsMelissaValidated = true;
    address.habaAddressIsValid = index !== -1;
    return address;
  }

  private initIds(): void {
    this.baseId = HabaQaId.forPage(HabaQaId.page.responsiveModal);
    this.closeButtonQaId = this.baseId.getButtonId(HabaQaId.elements.button.close);
  }
}
